<h1 mat-dialog-title>Lookup Failed</h1>
<div mat-dialog-content>
    <p>Unable to find Order ID:{{data.orderId}}<br>
    </p>
</div>
<div mat-dialog-actions>
    <button mat-raised-button mat-dialog-close (click)="close()">Close</button>
</div>